if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      if (this.form.querySelector('.input-id-not-bundle')) {
        this.form.querySelector('.input-id-not-bundle').disabled = false;
      }
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') ||
          document.querySelector('cart-items');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-items')) this.submitButton.setAttribute(
          'aria-haspopup', 'dialog');
      this.addedEvent = new CustomEvent('product:added');

      const addSuccessText = document.querySelector('.js-product-add-to-wishlist-success');
      const removeSucessText = document.querySelector('.js-product-remove-from-wishlist-success');
      
      document.addEventListener('wishlist-add-item', (e) => {
        addSuccessText.classList.remove('u-hidden');
        removeSucessText.classList.add('u-hidden');
      });

      document.addEventListener('wishlist-remove-item', (e) => {
        removeSucessText.classList.remove('u-hidden');
        addSuccessText.classList.add('u-hidden')
      });
    }

    get isPaymentButton() {
      return !!this.querySelector('[data-shopify="payment-button"]')
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      this.submitButton.setAttribute('aria-disabled', true);

      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').
          classList.
          remove('hidden');

      const config = fetchConfig('javascript');
      config.headers[ 'X-Requested-With' ] = 'XMLHttpRequest';
      delete config.headers[ 'Content-Type' ];

      const formData = new FormData(this.form);
      if (!!this.cart) formData.append('sections',
          this.cart.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;
      if (!!this.form.dataset.isBundleAvailable &&
          this.form.dataset.isBundleAvailable === 'incomplete') {
        document.dispatchEvent(new Event('bundle:error'));
        this.onFinally();
        return false;
      }
      
      console.log('this.isPaymentButton', this.isPaymentButton);

      if (evt.submitter === undefined && this.isPaymentButton) {
        this.onFinally();
        return false;
      }

      fetch(`${routes.cart_add_url}`, config).
          then((response) => response.json()).
          then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector(
                  '.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              return;
            }

            this.error = false;
            document.dispatchEvent(this.addedEvent); // dispatch event product added
            if (!!this.cart) this.cart.renderContents(response);
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener('modalClosed', () => {
                setTimeout(() => {
                  this.cart.renderContents(response);
                });
              }, {once: true});
              quickAddModal.hide(true);
            } else {
              //this.cart.renderContents(response);
            }
          }).
          catch((e) => {
            console.error(e);
          }).
          finally(() => {
            this.onFinally();
          });
    }

    onFinally() {
      this.submitButton.classList.remove('loading');
      if (this.cart &&
          this.cart.classList.contains('is-empty')) this.cart.classList.remove(
          'is-empty');
      if (!this.error) this.submitButton.removeAttribute('aria-disabled');
      this.querySelector('.loading-overlay__spinner').classList.add('hidden');
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage ||
          this.errorMessageWrapper.querySelector(
              '.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        if (errorMessage === 'Required parameter missing or invalid: id') {
          this.errorMessage.textContent = window.variantStrings.option_single;
        } else {
          this.errorMessage.textContent = errorMessage;
        }

        const offsetTop = this.errorMessageWrapper.offsetTop;
        window.scrollTo({
          top: offsetTop - 300,
          behavior: 'smooth',
        });
      }
    }
  });

}
